// eslint-disable-next-line func-names
(function ($, Drupal) {
  Drupal.behaviors.slideToggle = {
    attach: function attach() {
      // eslint-disable-next-line func-names
      $('.scroll-menu-link').click(function () {
        $('html, body').animate(
          {
            scrollTop: $('#scrollToMenu').offset().top,
          },
          1000,
        );
      });
    },
  };

  Drupal.behaviors.textIncrease = {
    attach: function attach() {
      // eslint-disable-next-line func-names
      $('.text-link').click(function () {
        $('.layout-content').toggleClass('js-text-increase');
      });
    },
  };

  Drupal.behaviors.backToTop = {
    attach: function attach() {
      // eslint-disable-next-line func-names
      $('.top-link').click(function () {
        $('html, body').animate(
          {
            scrollTop: $('#scrollToMenu').offset().top,
          },
          1000,
        );
      });

      $('.scroll-menu-link').click(function () {
        $('html, body').animate(
          {
            scrollTop: $('#scrollToMenu').offset().top,
          },
          1000,
        );
      });
    },
  };

  Drupal.behaviors.eventPopup = {
    attach: function attach() {
      $(document).mouseup(function (e) {
        const container = $("div[id*='windowManager']");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          container.hide();
        }
      });
    },
  };
  Drupal.behaviors.alertText = {
    attach() {
      $(document).ready(function () {
        // initialize
        const $width = $(document).width();
        const $scrollWidth = $(
          '.node--type-alert .field--name-field-text-long',
        ).outerWidth();
        $('.node--type-alert .field--name-field-text-long').css({
          right: `${-$scrollWidth}px`,
        });

        // animate
        function scroll() {
          $('.node--type-alert .field--name-field-text-long').animate(
            {
              right: $width,
            },
            30000,
            'linear',
            function () {
              $('.node--type-alert .field--name-field-text-long').css({
                right: `${-$scrollWidth}px`,
              });
              scroll();
            },
          );
        }

        $('.node--type-alert').hover(
          function () {
            $('.field--name-field-text-long').stop();
          },
          function () {
            scroll();
          },
        );
        scroll();
      });
    },
  };
})(jQuery, Drupal, drupalSettings);
